export const verticalsInSyncCatalogs = ['oab', 'carreiras-juridicas', 'concursos', 'militares', 'vestibulares', 'medicina'];
